import mixpanel from "mixpanel-browser";
import { MIXPANEL_TOKEN } from "@/config/vars";

const isDev = process.env.NODE_ENV === "development";
export const initMixpanel = () => {
  if (isDev && MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN, { debug: true });
  } else {
    console.error("MIXPANEL_TOKEN is missing or invalid.");
  }
};

export const trackEvent = (eventName: string, properties = {}) => {
  try {
    if (isDev && MIXPANEL_TOKEN) {
      mixpanel.track(eventName, { ...properties, platform: "web" });
    }
  } catch (error) {
    console.error(`Error tracking event "${eventName}":`, error);
  }
};

export const setUserId = (userId: string) => {
  try {
    if (isDev && MIXPANEL_TOKEN && userId) {
      mixpanel.identify(userId);
    }
  } catch (error) {
    console.error("Error setting user ID:", error);
  }
};

export const setUserProfile = (profile: Record<any, any>) => {
  try {
    if (isDev && MIXPANEL_TOKEN && profile?.id) {
      mixpanel.people.set({
        $distinct_id: profile?.id,
        $user_id: profile?.id,
        $name: profile?.full_name,
        $email: profile?.email,
        $avatar: profile?.photo_thumbnail_url,
        $created: profile.created_at,
        ...profile,
      });
    }
  } catch (error) {
    console.error("Error setting user profile:", error);
  }
};

export const aliasUser = (anonId: string, userId: string) => {
  try {
    if (isDev && MIXPANEL_TOKEN && anonId && userId) {
      mixpanel.alias(userId, anonId);
    }
  } catch (error) {
    console.error("Error aliasing user:", error);
  }
};

export const trackFormInput = (
  {
    form,
    page,
    name,
    field,
    value,
  }: {
    form: string;
    page: string;
    name: string;
    field: string;
    value: any;
  },
  props: Record<string, any> = {},
) => {
  try {
    if (isDev && MIXPANEL_TOKEN) {
      mixpanel.track(`${form}: ${name} Input Change`, {
        page,
        field,
        value,
        ...props,
      });
    }
  } catch (error) {
    console.error("Error tracking form input:", error);
  }
};
